/**
 * @module List Banner
 * @description
 */
import PropTypes from 'prop-types';
import Tooltip from '@/blocks/Tooltip';
import styles from './BannerList.module.css';

const defaultItems = [
  'Worry-free surfing and streaming',
  <>No data caps or overage charges<Tooltip disclosure="data-caps" /></>
];

/**
 * @function Component
 * @description
 */
const Component = ( { ...props } ) => {
  const {
    heading,
    items = defaultItems,
    theme = null
  } = props;

  return (
    <section className={ `component ${ styles.component } ${ theme && `u-theme-${ theme }` }` }>
      <div className="l-container">
        <div className={ styles.component__body }>
          { heading && <p className={ `h5 ${ styles.component__heading } ${ theme && styles[ `component__heading__${ theme } ` ] } ` }>{ heading }</p> }

          <ul className={ styles.component__list }>
            { items.map( ( item, index ) => (
              <li key={ index } className={ styles.component__listItem }>
                <span className={ `icon icon-checkmark1 ${ styles.component__icon } ${ theme && styles[ `component__icon__${ theme }` ] }` } />
                <span className={ styles.component__listCopy }>{ item }</span>
              </li>
            ) ) }
          </ul>
        </div>
      </div>
    </section>
  );
};

Component.propTypes = {
  heading: PropTypes.string,
  items: PropTypes.arrayOf( PropTypes.node ),
  theme: PropTypes.string
};

export default Component;
